import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';
import { deleteDrinkRequests } from '../../../../../services/Admin/NamedDrinksRequestApi';

const DeleteAiDrinkRequestDialog = ({ open, onClose, request, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    if (!request?.id) return;

    setLoading(true);
    setError('');
    try {
      // الدالة تقبل مصفوفة من الـ ids
      await deleteDrinkRequests([request.id]);

      // نجاح العملية
      onSuccess?.();
      handleClose();
    } catch (err) {
      console.error('خطأ في حذف الطلب:', err);
      setError(err.message || 'حدث خطأ في حذف الطلب');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle sx={{ fontWeight: 'bold', backgroundColor: '#fff3cd' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ color: 'warning.main' }} />
          تأكيد حذف الطلب
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* رسالة تحذيرية */}
        <Alert severity="warning" sx={{ mb: 2 }}>
          هل أنت متأكد من رغبتك في حذف هذا الطلب؟ لا يمكن التراجع عن هذه العملية.
        </Alert>

        {/* معلومات الطلب المراد حذفه */}
        <Box sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 1, mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>رقم الطلب:</strong> #{request?.id}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>اسم المشروب:</strong> {request?.drink_name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>المستخدم:</strong> {request?.user?.name}
          </Typography>
        </Box>

        {/* رسالة تحذيرية إضافية */}
        <Typography variant="caption" color="error" sx={{ display: 'block' }}>
          ⚠️ سيتم حذف جميع بيانات هذا الطلب بشكل نهائي
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          إلغاء
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {loading ? <CircularProgress size={24} /> : 'حذف'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAiDrinkRequestDialog;
